<svg:g class="grade-group"></svg:g>
<svg:g class="construct-group">
    <svg:circle cx="0" cy="0" class="construct-circle" filter="url(#inset-shadow)"></svg:circle>
    <svg:text class="construct-single-letter" dy="0.35em">{{ UtilsService.getLetterFromIndex(construct.order - 1) }}</svg:text>
</svg:g>
